import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { IUserMeta } from '../../../types/rest/IUserMeta';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';

export const authUserUpdateMeta = (
    meta: IUserMeta
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const authUser = getAuthUser(getState());
        const userPatch: IAuthUser = {
            id: authUser.id,
            meta
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
